import manifestJson from './site/manifest.json';
import type { SiteManifest } from '@/types';

export const siteManifest = manifestJson as SiteManifest;
